<template>
  <div class="card">
    <div class="card-content">
      <div class="property-item">
        <span class="property-label">Invoice Number:</span>
        <span class="property-value">{{ invoice.invoiceNumber }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Invoice Date:</span>
        <span class="property-value"
          >{{ formatDate(invoice.invoiceDate) }}
        </span>
      </div>
      <div class="property-item">
        <span class="property-label">Total Invoice Amount:</span>
        <span class="property-value">{{
          formatCurrency(invoice.invoiceAmount)
        }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Invoice Status:</span>
        <span class="property-value">{{ invoice.invoiceStatus }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Reference/PO #:</span>
        <span class="property-value">{{ invoice.referencePO }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">User Payment Type:</span>
        <span class="property-value">{{ invoice.userPaymentType }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Applicant Name:</span>
        <span class="property-value"
          >{{ invoice.firstName }} {{ invoice.lastName }}</span
        >
      </div>
      <div class="property-item">
        <span class="property-label">Applicant Company:</span>
        <span class="property-value">{{ invoice.company }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceTile",
  props: {
    invoice: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      try {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // Months are zero-indexed
        const day = date.getDate();
        return `${year}/${month}/${day}`;
      } catch (e) {
        console.error("Error formatting date:", e);
        return "Invalid Date";
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined || typeof value !== "number") {
        return "N/A";
      }

      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
  },
};
</script>

<style>
.card {
  border: 1px solid #333;
  border-radius: 8px;
  padding: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
}

.card-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 8px;
}

/* When there are exactly 3 columns visible, make them unequal */
@media (min-width: 1400px) {
  .card-content {
    grid-template-columns: 2fr 4fr 2fr;
  }
}

/* For smaller screens, maintain responsive behavior */
@media (max-width: 1399px) and (min-width: 650px) {
  .card-content {
    grid-template-columns: 2fr 4fr /*repeat(2, 1fr)*/;
  }
}

@media (max-width: 649px) {
  .card-content {
    grid-template-columns: 1fr;
  }
}

.property-item {
  display: flex;
  justify-content: space-between;
  padding: 2px 8px 2px 8px;
  background-color: #fff;
  border-radius: 4px;
}

.property-label {
  color: #333;
  white-space: nowrap; /* Prevent text wrapping */
  font-weight: 600;
}

.property-value {
  color: #333;
  /* font-weight: bold; */
}
</style>
